import { render } from "./VMultipleButtonSelect.vue?vue&type=template&id=4a06f5b9&ts=true"
import script from "./VMultipleButtonSelect.vue?vue&type=script&lang=ts"
export * from "./VMultipleButtonSelect.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__